import { render, staticRenderFns } from "./SegmentShareRate.vue?vue&type=template&id=3f64c72c"
import script from "./SegmentShareRate.vue?vue&type=script&lang=js"
export * from "./SegmentShareRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports